import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';


function PriorityGridDropdown({ onChangeDropdown, modelName, required, selectedValue, showLabel, autoFocus, onBlur, openMenuOnFocus }) {
    const [selectedPriorityOption, setSelectedPriorityOption] = useState([]);
    const [getPriorityOptions, setPriorityOptions] = useState([]);
    function handleChange(e, actionMeta) {
        setSelectedPriorityOption(e);
        onChangeDropdown(e, actionMeta);
    };
    function setDataOnLoad(data){
        let priorityOption = [];
        priorityOption = data.map(p => ({ value: p.PriorityId, label: p.PriorityName, name: 'Priority', description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setPriorityOptions(priorityOption);
        setSelectedPriorityOption(priorityOption.filter(x => x.value === selectedValue));
    }
    useEffect(() => {
        const fetchPriorities = async () => {
            try {
              let dropdownDetails = {
                UserId: localStorage.getItem('userId'),
                IsForDropodown: 1
              };
              const response = await axios.get(getApiBaseUrl() + "/getAllPriorities", {
                params: dropdownDetails
              });
              if (response.status === 200) {
                setDataOnLoad(response.data.data[0]);
              }
            } catch (error) {
              console.log(error);
            }
        };
        fetchPriorities();
    }, []);

    return (
        <>
            <Select
                className="PriorityGridDropdown"
                name={modelName}
                value={selectedPriorityOption ? selectedPriorityOption : []}
                isClearable
                options={getPriorityOptions || [] }
                onChange={handleChange}
                onBlur={onBlur}
                autoFocus={autoFocus}
                openMenuOnFocus={openMenuOnFocus}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: 32,
                      height: 32,
                      fontSize: '0.85rem',
                      borderColor: state.isFocused ? '#2684FF' : '#ccc',
                      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
                      '&:hover': {
                        borderColor: '#2684FF',
                      },
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: 32,
                      padding: '0 8px',
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: 32,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999, // make sure dropdown appears above modals/tables
                    }),
                  }}
                />
        </> 
    )
}

export default PriorityGridDropdown